import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    const baseTitle = 'ALIENS';
    const fullTitle = title ? `${title} | ${baseTitle}` : baseTitle;
    
    document.title = fullTitle;
    
    // Update favicon if needed (optional)
    // You can add logic here to change favicon per page if needed
    
    return () => {
      // Reset to default title when component unmounts
      document.title = baseTitle;
    };
  }, [title]);
};

export default usePageTitle;



